import { useEffect, useState } from "react";

/**
 * Computes editor panel height so the bottom edge sits near the viewport bottom.
 * @param {React.RefObject<HTMLElement>} rootRef - Root element whose top edge anchors the calculation
 * @param {number} bottomGap - Extra gap from viewport bottom (px)
 */
export const useEditorViewportHeight = (rootRef, bottomGap = 12) => {
  const [height, setHeight] = useState(640);

  useEffect(() => {
    const update = () => {
      const node = rootRef.current;
      if (!node) {
        return;
      }
      const top = node.getBoundingClientRect().top;
      const next = Math.max(420, Math.round(window.innerHeight - top - bottomGap));
      setHeight(next);
    };

    update();
    window.addEventListener("resize", update);
    const observer =
      typeof ResizeObserver !== "undefined"
        ? new ResizeObserver(update)
        : null;
    if (observer && rootRef.current) {
      observer.observe(rootRef.current);
    }

    return () => {
      window.removeEventListener("resize", update);
      observer?.disconnect();
    };
  }, [rootRef, bottomGap]);

  return height;
};

export default useEditorViewportHeight;
 